import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1200Model } from '../kymw1200.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
type OutputCycleItemInfoResponse = { FileName: string };

/**
 * ページ情報CSV出力サービス
 * @export OutputCycleItemInfoService
 * @class OutputCycleItemInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class OutputCycleItemInfoService extends PlessJsonResponderSub<OutputCycleItemInfoResponse> {
  model: KYMW1200Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof OutputCycleItemInfoService
   */
  private getBody(): PlessRequest {
    const param = {
      MediumType: this.model.searchedMediumType,
      BuyerCodes: this.model.searchedBuyerCode,
      CoopCode: this.model.searchedCoopCode,
      StartOrderCode: this.model.searchedOrderCodeFrom,
      EndOrderCode: this.model.searchedOrderCodeTo,
      SupplierCode: this.model.isSupplier ? this.model.userSupplierCode : null,
      PastCycle: this.model.pastCycle,
    };
    if (!param.SupplierCode) delete param.SupplierCode;

    return new PlessRequest({ parameter: param });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof OutputCycleItemInfoService
   */
  execute(model: KYMW1200Model, f: () => void = null): void {
    this.model = model;
    this.model.outputPath = '';
    this.calbak = f;
    this.send('outputCycleItemInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof OutputCycleItemInfoService
   */
  success(data: OutputCycleItemInfoResponse) {
    this.model.outputPath = data.FileName;
    if (this.calbak) this.calbak();
  }
}
